export default __webpack_public_path__ + "static/media/silverthread.b294a977.png";